import { CalendarEvent } from '@/types/community/calendar';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

function getRelativeDateRange(startDaysOffset: number, endDaysOffset: number, startHour: number = 9, startMinute: number = 0, endHour: number = 17, endMinute: number = 0): { start: Date; end: Date } {
  const start = getRelativeDate(startDaysOffset, startHour, startMinute);
  const end = getRelativeDate(endDaysOffset, endHour, endMinute);
  return { start, end };
}

export const events: CalendarEvent[] = [
  // Past month events (last month)
  {
    id: 'EVT001',
    title: 'Community Meeting',
    description: 'Monthly community meeting to discuss important matters.',
    ...getRelativeDateRange(-45, -45, 18, 0, 20, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT002',
    title: 'Pool Maintenance',
    description: 'Scheduled pool maintenance and cleaning.',
    ...getRelativeDateRange(-40, -40, 9, 0, 12, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT003',
    title: 'Security Training',
    description: 'Security staff training session.',
    ...getRelativeDateRange(-35, -35, 14, 0, 16, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP004',
      name: 'Security Supervisor',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT004',
    title: 'Book Club Meeting',
    description: 'Monthly book club discussion.',
    ...getRelativeDateRange(-30, -30, 18, 30, 20, 0),
    type: 'activity',
    hostedBy: {
      id: 'RES002',
      name: 'Jane Smith',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT005',
    title: 'Emergency Drill',
    description: 'Monthly emergency evacuation drill.',
    ...getRelativeDateRange(-25, -25, 15, 0, 16, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP004',
      name: 'Security Supervisor',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Current month events (this month)
  {
    id: 'EVT006',
    title: 'Yoga Class',
    description: 'Weekly yoga session for all residents.',
    ...getRelativeDateRange(-15, -15, 7, 0, 8, 30),
    type: 'activity',
    hostedBy: {
      id: 'EMP002',
      name: 'Fitness Instructor',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT007',
    title: 'Resident Social Hour',
    description: 'Monthly social gathering for residents to meet and mingle.',
    ...getRelativeDateRange(-10, -10, 19, 0, 21, 0),
    type: 'activity',
    hostedBy: {
      id: 'RES001',
      name: 'John Doe',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT008',
    title: 'Gym Equipment Installation',
    description: 'New gym equipment installation and setup.',
    ...getRelativeDateRange(-5, -5, 8, 0, 17, 0),
    type: 'other',
    hostedBy: {
      id: 'VEN001',
      name: 'Fitness Equipment Co.',
      type: 'vendor'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT009',
    title: 'Board Meeting',
    description: 'Monthly board meeting to discuss community matters.',
    ...getRelativeDateRange(-2, -2, 16, 0, 18, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT010',
    title: 'Swimming Lessons',
    description: 'Swimming lessons for children.',
    ...getRelativeDateRange(-1, -1, 10, 0, 11, 30),
    type: 'activity',
    hostedBy: {
      id: 'EMP005',
      name: 'Swimming Instructor',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Future events (next few days)
  {
    id: 'EVT011',
    title: 'Community BBQ',
    description: 'Annual community barbecue in the courtyard.',
    ...getRelativeDateRange(2, 2, 12, 0, 18, 0),
    type: 'activity',
    hostedBy: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT012',
    title: 'Fitness Assessment',
    description: 'Free fitness assessment for all residents.',
    ...getRelativeDateRange(5, 5, 9, 0, 17, 0),
    type: 'activity',
    hostedBy: {
      id: 'EMP002',
      name: 'Fitness Instructor',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT013',
    title: 'Maintenance Review',
    description: 'Quarterly maintenance review meeting.',
    ...getRelativeDateRange(8, 8, 14, 0, 16, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT014',
    title: 'Movie Night',
    description: 'Outdoor movie screening in the courtyard.',
    ...getRelativeDateRange(10, 10, 19, 30, 22, 0),
    type: 'activity',
    hostedBy: {
      id: 'RES003',
      name: 'Mike Johnson',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT015',
    title: 'Security System Upgrade',
    description: 'Security system upgrade and testing.',
    ...getRelativeDateRange(12, 12, 8, 0, 16, 0),
    type: 'other',
    hostedBy: {
      id: 'VEN002',
      name: 'Security Systems Inc.',
      type: 'vendor'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Next month events
  {
    id: 'EVT016',
    title: 'Holiday Decorations',
    description: 'Installation of holiday decorations throughout the community.',
    ...getRelativeDateRange(25, 25, 9, 0, 17, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT017',
    title: 'New Year Party Planning',
    description: 'Planning meeting for New Year celebration.',
    ...getRelativeDateRange(30, 30, 18, 0, 20, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT018',
    title: 'Winter Pool Closure',
    description: 'Annual winter pool closure and maintenance.',
    ...getRelativeDateRange(35, 35, 8, 0, 16, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT019',
    title: 'Resident Survey',
    description: 'Annual resident satisfaction survey distribution.',
    ...getRelativeDateRange(40, 40, 10, 0, 18, 0),
    type: 'activity',
    hostedBy: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT020',
    title: 'Budget Review Meeting',
    description: 'Annual budget review and planning meeting.',
    ...getRelativeDateRange(45, 45, 14, 0, 17, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 